import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const eagleCrestNationalMetadata = {
  id: 'eagle-crest-national',
  name: 'Eagle Crest National',
  description:
    'A formal national championship course with sculpted fairways, mature trees, strategic sand and exacting elevated greens.',
  environmentPreset: 'eagle-crest',
  metadata: {
    location: 'Crestmont, Franklin',
    regionType: 'championship',
    difficulty: 94,
    typicalWind: [5, 14] as const,
    greenSpeed: [11.5, 12.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'A complete-game examination on fast, severe green complexes',
    signatureHoles: [6, 11, 15, 18],
    tournamentEventId: 'event-18',
    previewTheme: 'eagle-crest',
    environmentPalette: {
      fairway: '#3f7442',
      rough: '#294d31',
      bunker: '#eee1be',
      water: '#35637a',
      haze: '#bccbd2',
      sky: '#7198ba',
      rock: '#77796d',
    },
    vegetationStyle: 'mature formal hardwood corridors',
    terrainStyle: terrainPreset('eagle-crest', 24, 135, 1.1).id,
    sunlightDirection: 'clear championship afternoon',
    distantScenery: 'clubhouse terraces and wooded ridges',
    waterStyle: 'clear creeks and formal ponds',
    eventPresentation: {
      accentColor: '#b79a55',
      mark: 'CROWN MAJOR',
      subtitle: 'The complete examination',
      loadingCopy: 'A national championship awaits',
      identityLine: 'Formal, prestigious and uncompromising',
      tierLabel: 'MAJOR CHAMPIONSHIP',
    },
  },
};
const pars = [4, 5, 4, 3, 4, 3, 5, 4, 4, 4, 5, 4, 3, 4, 4, 3, 5, 4],
  yards = [
    445, 550, 465, 205, 440, 235, 570, 455, 430, 455, 540, 450, 190, 435, 480, 215, 570, 465,
  ];
const names = [
  'Ceremonial Drive',
  'Founders',
  'Long Standard',
  'Gallery',
  'Oak Turn',
  'Crest Creek',
  'Twin Decisions',
  'High Rough',
  'Halfway House',
  'National Rise',
  'Second Choice',
  'Eagle Bend',
  'White Sand',
  'Laurel',
  'Uphill Crown',
  'Long Iron',
  'Final Chance',
  'Grand Terrace',
];
const o: Partial<HolePlan>[] = [];
o[5] = { water: 'carry', bunkerCount: 4 };
o[10] = {
  splitFairway: true,
  water: 'right',
  landingZones: [{ distance: 290, width: 62, preferredSide: 'left' }],
};
o[14] = { elevation: { tee: 0, landing: 10, green: 25 }, bunkerCount: 5 };
o[17] = {
  water: 'left',
  elevation: { tee: 2, landing: 8, green: 16 },
  greenRadius: 21,
  bunkerCount: 5,
};
export const createEagleCrestNationalDocument = () =>
  authorCourse({
    ...eagleCrestNationalMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({ ...p, trees: p.trees ?? 10 })),
  });
